import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { SearchItem } from 'out-game/types'
import { Gradient, Routes } from 'out-game/constants'
import * as actions from 'out-game/actions/ui'
import { Modal, Typography, TextField, IconButton } from 'out-game/components'
import { ReactComponent as Cross } from 'out-game/images/icons/cross-icon.svg'
import { ReactComponent as Loupe } from 'out-game/images/icons/loupe-icon.svg'
import { useAction } from 'out-game/hooks'
import { useRequestSearch } from 'out-game/hooks/useRequest'

const useStyles = makeStyles({
  root: {
    '& .og-modal_inner': {
      marginTop: 'auto',
      marginBottom: 'auto',
      minHeight: '60%',
      maxHeight: '100vh',
      overflowY: 'auto',
      width: 963,
    },
    alignItems: 'flex-start',
  },
  modal: {
    mixBlendMode: 'darken',
    backgroundColor: '#000000D0',
  },
  textField: {
    '& .MuiInput-input': {
      fontSize: 39,
      fontWeight: 'lighter',
    },
    '& .MuiInput-root': {
      paddingLeft: 25,
      paddingRight: 25,
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      columnGap: 25,
    },
  },
  iconClean: {
    width: 29,
    height: 29,
  },
  iconLoupe: {
    width: 41,
    height: 41,
  },
  resultContainer: {
    marginTop: 70,
  },
  occurrence: {
    '&:hover': {
      background: Gradient.Light,
    },
    '&:not(:hover)': {
      background: Gradient.Dark,
    },
    cursor: 'pointer',
    fontSize: 16,
    fontFamily: 'Roboto Condensed',
    color: 'white',
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
    paddingBottom: 20,
  },
  occurrenceTitle: {
    marginTop: 15,
    marginBottom: 10,
  },
})

type OccurrenceProps = React.HTMLProps<HTMLDivElement> & {
  readonly title: string
  readonly to: string
}

const Occurrence: React.FC<OccurrenceProps> = (props) => {
  const classes = useStyles()
  const history = useHistory()
  const setSearchVisible = useAction(actions.setSearchVisible)
  const { title, to, ...restProps } = props

  return (
    <>
      <Typography
        size={16}
        className={classes.occurrenceTitle}
        color="Emphasized"
      >
        {title}
      </Typography>
      <div
        className={classes.occurrence}
        onClick={() => {
          history.push(to)
          setSearchVisible(false)
        }}
        {...restProps}
      />
    </>
  )
}

const Search: React.FC = (props) => {
  const classes = useStyles()
  const setSearchVisible = useAction(actions.setSearchVisible)
  const searchVisible = useSelector((state) => state.ui.searchVisible)
  const refInput = React.useRef<HTMLInputElement>()
  const [query, setQuery] = React.useState('')
  const [done, setDone] = React.useState(false)
  const [result, setResult] = React.useState<Array<SearchItem>>([])
  const [requestSearch] = useRequestSearch()

  React.useEffect(() => {
    if (!searchVisible) {
      return
    }
    if (refInput.current) {
      refInput.current.focus()
    }
    const listener = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setSearchVisible(false)
      }
    }
    console.log('adding listener...')
    window.addEventListener('keydown', listener)
    return () => {
      console.log('removing listener...')
      window.removeEventListener('keydown', listener)
    }
  }, [searchVisible, setSearchVisible])

  const doSearch = async () => {
    if (query.length < 3) {
      return
    }
    const result = await requestSearch({ query })
    setDone(true)
    setResult(result.data)
    console.log(result.data)
  }

  return (
    <Modal
      open={searchVisible}
      onClose={() => setSearchVisible(false)}
      className={classes.root}
      maskProps={{ className: classes.modal }}
    >
      <Typography size={29} weight="lighter" color="Emphasized">
        Введите название интересующего Вас товара или описание к нему:
      </Typography>
      <TextField
        className={classes.textField}
        fill="linear-gradient(151.58deg, #35455C 0%, #6E7C90 100%)"
        value={query}
        onChange={setQuery}
        onKeyUp={(event) => event.key === 'Enter' && doSearch()}
        inputRef={refInput}
        startAdornment={
          <IconButton
            Icon={() => <Cross className={classes.iconClean} />}
            onClick={() => {
              setQuery('')
              setDone(false)
            }}
          />
        }
        endAdornment={
          <IconButton
            Icon={() => <Loupe className={classes.iconLoupe} />}
            onClick={() => doSearch()}
          />
        }
      />
      <div className={classes.resultContainer}>
        {done && !result.length ? (
          <Typography size={24} style={{ textAlign: 'center' }}>
            По Вашему запросу ничего не найдено.
          </Typography>
        ) : (
          result.map((record) => (
            <Occurrence
              title="Предмет"
              to={Routes.MerchPage + '/' + record.item_id}
              key={record.id}
            >
              <Typography color="Primary" size={24}>
                {record.name}
              </Typography>
            </Occurrence>
          ))
        )}
      </div>
    </Modal>
  )
}

export default Search
